import type { JSX, PropsWithChildren } from 'react';

import { ClientRender } from '@change-corgi/core/react/ssr/render';

import { isLoaded } from 'src/app/shared/utils/async';

import { usePageContext } from './hook';
import { StartAPetitionPageFcmContextProvider } from './pageFcm';
import { StartAPetitionPageFcmExperimentsContextProvider } from './pageFcmExperiments';
import { StepStateProvider } from './pageState';

type Props = {
	loadingFallback: JSX.Element;
};

export function StartAPetitionPageContextProvider({
	children,
	loadingFallback,
}: PropsWithChildren<Props>): JSX.Element | null {
	const pageContextState = usePageContext();

	if (!isLoaded(pageContextState)) return loadingFallback;

	const { pageFcm, pageFcmExperiments } = pageContextState;

	return (
		<StartAPetitionPageFcmContextProvider pageFcm={pageFcm}>
			<StartAPetitionPageFcmExperimentsContextProvider pageFcmExperiments={pageFcmExperiments}>
				{/* StepState relies on local storage so is only initialized on the client, so no SSR :( */}
				<ClientRender>
					<StepStateProvider>{children}</StepStateProvider>
				</ClientRender>
			</StartAPetitionPageFcmExperimentsContextProvider>
		</StartAPetitionPageFcmContextProvider>
	);
}
